// Shared draft store for the new planner UI (monthly + weekly)
// Goal: preserve edits across tab switches and full refresh until user saves.

const SCHEMA_VERSION = 1

const safeParse = (s, fallback = null) => {
  try {
    return JSON.parse(s)
  } catch (e) {
    return fallback
  }
}

const safeStringify = (v) => {
  try {
    return JSON.stringify(v)
  } catch (e) {
    return ''
  }
}

const safeLsGet = (k) => {
  try {
    return localStorage.getItem(k)
  } catch (e) {
    return null
  }
}

const safeLsSet = (k, v) => {
  try {
    if (v === null || typeof v === 'undefined') {
      localStorage.removeItem(k)
    } else {
      localStorage.setItem(k, String(v))
    }
  } catch (e) {}
}

export const makePlannerDraftKey = ({ clientId, locationClassId, planSettingsId, monthlyPlanSettingsId, weeklyPlanSettingsId }) => {
  const monthlyId = monthlyPlanSettingsId || planSettingsId || 'n/a'
  const weeklyId = weeklyPlanSettingsId || planSettingsId || 'n/a'
  return `plannerDraft.v${SCHEMA_VERSION}.${clientId || '0'}.${locationClassId || '0'}.${monthlyId}.${weeklyId}`
}

export const loadPlannerDraft = (key) => {
  const raw = safeLsGet(key)
  if (!raw) return null
  return safeParse(raw, null)
}

export const savePlannerDraft = (key, draft) => {
  const payload = {
    schemaVersion: SCHEMA_VERSION,
    updatedAt: new Date().toISOString(),
    ...draft,
  }
  safeLsSet(key, safeStringify(payload))
}

export const clearPlannerDraft = (key) => {
  safeLsSet(key, null)
}

// Prefer named exports.
// (No default export to keep linters happy.)
